import React from 'react';
import {connect} from 'react-redux';

import ProductPrice from './product-price';
import { withProductPrice } from './with-product-price';
import { withError } from '../../../shared/components/error-boundary';

// Convenience component to display product price with just the product. 
// Wire in product price catalog and user from store directl
function mapStateToProps(state, ownProps) {
    return {
        price: ownProps.price,
        user: state.userData.profileData.personData
    }
}


export default withProductPrice(connect(mapStateToProps, null)( withError(ProductPrice,<div className={"prd-price"} />)));
